/* ARRAY - Featured product banner.
   Progressive enhancement only. Selection itself is a CSS radio group and works
   with this file blocked; this adds optional rotation and the prev/next arrows.
   The arrows are display:none until .fp--js is set, so they never sit there
   dead for a visitor without JavaScript.

   Rotation stops on hover, on keyboard focus inside the banner, while the tab
   is hidden, and whenever the visitor picks a product themselves. */
(function () {
  if (window.__bdFeatBound) return;
  window.__bdFeatBound = true;

  var ROOT = '[data-fp-root]';
  var TICK = 250;

  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
  function roots() { return document.querySelectorAll(ROOT); }
  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function radios(root) { return root.querySelectorAll('.fp-radio'); }

  function index(root) {
    var r = radios(root);
    for (var k = 0; k < r.length; k++) if (r[k].checked) return k;
    return 0;
  }

  function step(root, by) {
    var r = radios(root);
    if (r.length < 2) return;
    var i = ((index(root) + by) % r.length + r.length) % r.length;
    r[i].checked = true;
    root.__el = 0;
  }

  function tick(root) {
    var t = now();
    var dt = t - (root.__last == null ? t : root.__last);
    root.__last = t;
    if (document.hidden || reduced() || root.__hold || !root.__dur) return;
    if (dt < 0 || dt > 4000) dt = TICK;
    root.__el = (root.__el || 0) + dt;
    if (root.__el >= root.__dur) step(root, 1);
  }

  function start(root) {
    root.classList.add('fp--js');
    if (root.__timer) { clearInterval(root.__timer); root.__timer = null; }
    root.__dur = parseInt(root.getAttribute('data-interval') || '0', 10) || 0;
    root.__last = now();
    if (!root.__dur || reduced() || radios(root).length < 2) return;
    root.__timer = setInterval(function () { tick(root); }, TICK);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var root = e.target.closest(ROOT);
    if (!root) return;
    var arrow = e.target.closest('[data-fp-step]');
    if (arrow) {
      e.preventDefault();
      step(root, parseInt(arrow.getAttribute('data-fp-step'), 10) || 1);
      return;
    }
    /* a manual pick resets the clock so the slide is not yanked away */
    if (e.target.closest('.fp-thumb')) root.__el = 0;
  });

  document.addEventListener('change', function (e) {
    var root = e.target.closest && e.target.closest(ROOT);
    if (root) root.__el = 0;
  });

  document.addEventListener('pointerover', function (e) {
    var root = e.target.closest && e.target.closest(ROOT);
    if (root) root.__hold = true;
  });
  document.addEventListener('pointerout', function (e) {
    var root = e.target.closest && e.target.closest(ROOT);
    if (root && !root.contains(e.relatedTarget)) root.__hold = false;
  });
  document.addEventListener('focusin', function (e) {
    var root = e.target.closest && e.target.closest(ROOT);
    if (root) root.__hold = true;
  });
  document.addEventListener('focusout', function (e) {
    var root = e.target.closest && e.target.closest(ROOT);
    if (root && !root.contains(e.relatedTarget)) root.__hold = false;
  });
  document.addEventListener('visibilitychange', function () {
    var r = roots();
    for (var i = 0; i < r.length; i++) r[i].__last = now();
  });

  function initAll() {
    var r = roots();
    for (var i = 0; i < r.length; i++) start(r[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
